import "../App.css";

export default function Home() {
  return "home";
}
